module.exports = __webpack_public_path__ + "img/qr_code.32a8123c.jpg";